import { useRef } from "react";

/// A custom hook which ensures that a single instance of a ref value is created and returned once-off.
/// Works around the limitation of `useRef` not supporting an initializer function.
/// NOTE: If the initializer function returns `null`, that function will be executed on every render.
/// In the case where the value is not required to be initialized immediately, consider using `useRef` directly instead.
export function useSingleton<T>(init: () => T): T {
    const ref = useRef<T>(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}